// src/hooks/useIsMobile.js
import { useState, useEffect } from 'react';

/**
 * Returns true if window.innerWidth <= breakpoint.
 * Recalculates on resize.
 * @param {number} breakpoint in px (default 768)
 */
export default function useIsMobile(breakpoint = 768) {
  // initialize from window (guard for SSR)
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth <= breakpoint : false
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= breakpoint);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
}
